{
  "kampanya": {
    "Baslik": "Kampanya Tanımları",
    "Ad": "Kampanya Adı",
    "BasTarih": "Başlangıç Tarihi",
    "BitTarih": "Bitiş Tarihi",
    "HedefEkle": "Hedef Ataması Yap",
    "Kullanici Ata": "Kullanıcı Ataması Yap",
    "Kullanici Seç": "Personel / Kullanıcı Seç",
    "Kullanici Ad Soyad": "Kullanıcı Ad, Soyad",
    "Hedef Tutar": "Tutar (₺)",
    "Hedef Adet": "Adet",
    "PDO Orani": "PDO Oranı (%)",
    "Urun Sec": "Sadece Ürüne Özel",
    "Grup Sec": "Bütün Gruba Özel (Grup Seçimi)",
    "Urun Veya Grup": "Grup/Ürün Adı",
    "Filtrele": "Filtrele",
    "Temizle": "Temizle",
    "ARA": "ARA",
    "Kapat": "Kapat",
    "Ara": "Ara...",
    "Hepsi": "Tümü",
    "Aktif": "Aktif",
    "Pasif": "Pasif",
    "Durum": "Durum",
    "Aciklama": "Description",
    "Duzenle": "Düzenle",
    "Yeni Ekle": "Yeni Ekle",
    "Ekle": "Ekle",
    "Guncelle": "Güncelle",
    "Kaydet": "Kaydet",
    "Iptal": "İptal",
    "Islem": "İşlem",
    "Yenile": "Yenile",
    "Data Yenile": "Veriyi Yenile",
    "Hedef yok": "Atanmış hedef bulunamadı",
    "Kullanici yok": "Atanmış kullanıcı bulunamadı",
    "Hedef Dolar": "Dollar Target ($)",
    "Hedef APE": "APE Target",
    "Tekil Kullanıcı Ekle": "Add Single User",
    "Toplu Kullanıcı Ekle (Takım/Şube)": "Add Bulk Users (Team/Branch)",
    "Takım Bazlı": "Takım Bazlı Seçim",
    "Şube Bazlı": "Branch Based Selection",
    "Toplu Ekle": "Add Bulk",
    "Takım": "Takım"
  }
}
